// @flow
import React from 'react'
import { containerIds } from 'redux/modules/ui'

type PropTypes = {
  ui: {
    selectedSortType: string,
  },
  setUIState: Function,
}

const SortTypes = {
  RECOMMEND: 'RECOMMEND',
  PRICE: 'PRICE',
  CAPACITY: 'CAPACITY',
  CREATED_AT: 'CREATED_AT',
}

export default class SelectSort extends React.Component {
  constructor(props: PropTypes) {
    super(props)

    props.setUIState(containerIds.SPACE, {
      selectedSortType: SortTypes.RECOMMEND,
    })
  }

  props: PropTypes

  render() {
    const { ui, setUIState } = this.props
    return (
      <span className="service-select">
        <select
          name="sort"
          id="sort"
          className="service-select__sort"
          value={ui.selectedSortType}
          onChange={e =>
            setUIState(containerIds.SPACE, { selectedSortType: e.target.value })
          }
        >
          <option value={SortTypes.RECOMMEND}>
            {i18n.t('page.shared.sortType.recommend')}
          </option>
          <option value={SortTypes.PRICE}>
            {i18n.t('page.shared.sortType.price')}
          </option>
          <option value={SortTypes.CAPACITY}>
            {i18n.t('page.shared.sortType.capacity')}
          </option>
          <option value={SortTypes.CREATED_AT}>
            {i18n.t('page.shared.sortType.createdAt')}
          </option>
        </select>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/SelectSort.jsx